<template>
  <nav
    :class="[
      'navbar main-header-nav-container',
      mobileNavClass,
      mobileNavSearchClass,
      homepageColor,
      { 'template-index': isHomepage, fixed: mainFixed }
    ]"
    ref="main"
  >
    <div class="main-header-nav-inner-container container">
      <div class="mobile-search-icon-form-container">
        <div class="mobile-search-icon-container">
          <navbar-mobile-search @toggle-search="toggleSearch"></navbar-mobile-search>
        </div>
      </div>
      <div class="logo-nav-container">
        <navbar-logo :image="logo" :large-image="logoLarge" :alt="shopName" :h1="h1"></navbar-logo>
        <div class="nav-links-dropdown-content-container">
          <div class="nav-links-dropdown-inner-content-container">
            <ul
              class="nav-main-links-container"
              v-for="(block, index) in blocks"
              :key="`nav-main-links-container_${index}`"
            >
              <template v-if="block.type !== 'no_dropdown'">
                <li
                  class="header__menu-item"
                  aria-haspopup="true"
                  v-if="isValidBlockType(block.type)"
                >
                  <component
                    class="header__menu-main-link"
                    :is="block.url ? 'a' : 'span'"
                    :href="block.url"
                  >
                    <span class="header__menu-main-link-text">
                      {{
                      block.title
                      }}
                    </span>
                  </component>
                  <component :is="blockTypes[block.type].desktop" :block="block"></component>
                </li>
              </template>
              <template v-else>
                <li class="header__menu-item" v-if="block.type === 'no_dropdown'">
                  <component
                    class="header__menu-main-link"
                    :is="block.url ? 'a' : 'span'"
                    :class="{ 'header__menu-main-link--solo': block.url }"
                    :href="block.url"
                  >
                    <span class="header__menu-main-link-text">
                      {{
                      block.title
                      }}
                    </span>
                  </component>
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>
      <div class="desktop-header-search-cart-container">
        <div class="header-search-container">
          <div class="navbar__search">
            <navbar-search :enablePredictiveSearch="enablePredictiveSearch"></navbar-search>
          </div>
        </div>
        <navbar-account></navbar-account>
        <div class="cart-icon-container">
          <navbar-cart :cartBubbleColors="cartBubbleColors"></navbar-cart>
        </div>
      </div>
      <div class="mobile-cart-menu-container" :class="mobileNavClass">
        <navbar-cart :cartBubbleColors="cartBubbleColors"></navbar-cart>
        <div class="navbar__mobile">
          <navbar-hamburger
            @open="openMenu"
            @close="closeMenu"
            @openSearch="openSearch"
            :isMenuOpen="isMenuOpen"
            :showSearch="showSearch"
            ref="hamburger"
          ></navbar-hamburger>
          <transition name="off-canvas-top">
            <div
              class="navbar__mobile__nav navbar__mobile__nav--search"
              v-if="showSearch"
              v-scroll-lock="showSearch"
            >
              <search-form
                :enable-predictive-search="enablePredictiveSearch"
                @close-search="closeSearch"
              ></search-form>
            </div>
            <div
              class="navbar__mobile__nav nav-links-dropdown-content-container"
              v-else-if="isMenuOpen"
              :style="mobileMenuOffset > 0 && { top: mobileMenuOffset + 'px' }"
            >
              <accordion-group class="navbar__mobile__linklist">
                <template
                  v-for="(block, index) in blocks"
                >
                  <!-- Meganav -->
                  <navbar-mobile-accordion
                    v-if="isValidBlockType(block.type)"
                    class="navbar__mobile__category nav-main-links-container accordionClass"
                    :key="`navbar-mobile-link-block_${index}`"
                    :heading="block.title"
                    :headinglink="block.url"
                  >
                    <component
                      class="header__dropdown-container"
                      :is="blockTypes[block.type].mobile"
                      :block="block"
                    ></component>
                  </navbar-mobile-accordion>

                  <!-- Text / Link -->
                  <div
                    v-else-if="block.type === 'no_dropdown'"
                    class="nav-main-links-container"
                    :key="`navbar-mobile-link-block_${index}`"
                  >
                    <div class="header__menu-item">
                      <component
                        class="header__menu-main-link"
                        :is="block.url ? 'a' : 'span'"
                        :href="block.url"
                      >
                        <span class="header__menu-main-link-text">
                          {{ block.title }}
                        </span>
                      </component>
                    </div>
                  </div>
                </template>
              </accordion-group>
              <div class="mobile-dropdown__helper-links-main-container">
                <div
                  class="mobile-dropdown__helper-main-link-container"
                  v-if="helperlinks.helper_1.title"
                >
                  <a
                    class="mobile-dropdown__helper-main-link"
                    :href="helperlinks.helper_1.url"
                    v-if="helperlinks.helper_1.url.length > 0"
                  >
                    <p class="mobile-helper-title">{{ helperlinks.helper_1.title }}</p>
                  </a>
                </div>
              </div>
              <div class="mobile-dropdown__helper-links-main-container">
                <div class="mobile-dropdown__helper-main-link-container">
                  <div class="mobile-dropdown__helper-main-link">
                    <p class="mobile-helper-title">Language</p>
                    <span class="ly-custom-1 lang-selector">
                      <select
                        data-breakpoint="1"
                        class="ly-languages-switcher mobile-languages ly-native-select custom ly-breakpoint-2 ly-custom ly-bright-theme"
                        style="font-size: 14px;  color: #ffffff;"
                        v-html="langifySelectInnerHtml"
                        @change="onMobileLanguageChange"
                      ></select>
                    </span>
                  </div>
                </div>
              </div>
              <div class="mobile-dropdown__helper-links-main-container">
                <div
                  class="mobile-dropdown__helper-main-link-container"
                  v-if="helperlinks.helper_2.title"
                >
                  <a
                    class="mobile-dropdown__helper-main-link"
                    :href="helperlinks.helper_2.url"
                    v-if="helperlinks.helper_2.url.length > 0"
                  >
                    <p class="mobile-helper-title">{{ helperlinks.helper_2.title }}</p>
                  </a>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapState } from 'vuex';

import SearchForm from '@/scripts/components/forms/SearchForm.vue';
import Icon from '@/scripts/components/basic/Icon.vue';
import AccordionGroup from '@/scripts/components/basic/AccordionGroup.vue';

import NavbarCart from './NavbarCart.vue';
import NavbarAccount from './NavbarAccount.vue';
import NavbarHamburger from './NavbarHamburger.vue';
import NavbarLogo from './NavbarLogo.vue';
import NavbarSearch from './NavbarSearch.vue';
import NavbarMobileSearch from './NavbarMobileSearch.vue';
import NavbarMobileAccordion from './NavbarMobileAccordion.vue';
import NavbarMobileLogoLinks from './NavbarMobileLogoLinks.vue';

import NavbarMobileTextBlocks from '@/scripts/components/sections/NavbarMobileTextBlocks.vue';
import NavbarMobileTextLargeImage from '@/scripts/components/sections/NavbarMobileTextLargeImage.vue';
import NavbarMobileTextSmallImageBlocks from '@/scripts/components/sections/NavbarMobileTextSmallImageBlocks.vue';
import NavbarMobileSmallImageBlocks from '@/scripts/components/sections/NavbarMobileSmallImageBlocks.vue';
import NavbarDesktopTextBlocks from '@/scripts/components/sections/NavbarDesktopTextBlocks.vue';
import NavbarDesktopTextLargeImage from '@/scripts/components/sections/NavbarDesktopTextLargeImage.vue';
import NavbarDesktopTextSmallImageBlocks from '@/scripts/components/sections/NavbarDesktopTextSmallImageBlocks.vue';
import NavbarDesktopSmallImageBlocks from '@/scripts/components/sections/NavbarDesktopSmallImageBlocks.vue';

export default {
  name: 'Navbar',
  components: {
    NavbarCart,
    NavbarAccount,
    NavbarHamburger,
    NavbarLogo,
    Icon,
    NavbarSearch,
    NavbarMobileSearch,
    SearchForm,
    NavbarMobileTextBlocks,
    NavbarMobileTextLargeImage,
    NavbarMobileTextSmallImageBlocks,
    NavbarMobileSmallImageBlocks,
    NavbarDesktopTextBlocks,
    NavbarDesktopTextLargeImage,
    NavbarDesktopTextSmallImageBlocks,
    NavbarDesktopSmallImageBlocks,
    AccordionGroup,
    NavbarMobileAccordion,
    NavbarMobileLogoLinks,
  },
  props: {
    logo: String,
    logoLarge: String,
    shopName: String,
    title: String,
    url: String,
    homepageColor: String,
    h1: {
      type: Boolean,
      default: false,
    },
    blocks: {
      type: Array,
      default: () => [],
    },
    helperlinks: Object,
    cartBubbleColors: Object,
    logoTabs: {
      type: Object,
      default: () => ({
        enabled: Boolean,
        tabBorderColorClass: String,
        logo1: {
          type: Object,
          default: () => ({
            imgUrl: String,
            url: String,
          }),
        },
        logo2: {
          type: Object,
          default: () => ({
            imgUrl: String,
            url: String,
          }),
        },
        logo3: {
          type: Object,
          default: () => ({
            imgUrl: String,
            url: String,
          }),
        },
      }),
    },
    enablePredictiveSearch: Boolean,
  },
  data() {
    return {
      isMenuOpen: false,
      mainFixed: false,
      showSearch: false,
      mainOffset: null,
      mainOffsetMobile: null,
      mobileMenuOffset: 0,
      langifySelectInnerHtml: '',
      blockTypes: {
        text_blocks: {
          mobile: 'navbar-mobile-text-blocks',
          desktop: 'navbar-desktop-text-blocks',
        },
        text_large_image: {
          mobile: 'navbar-mobile-text-large-image',
          desktop: 'navbar-desktop-text-large-image',
        },
        text_small_image_blocks: {
          mobile: 'navbar-mobile-text-small-image-blocks',
          desktop: 'navbar-desktop-text-small-image-blocks',
        },
        small_image_blocks: {
          mobile: 'navbar-mobile-small-image-blocks',
          desktop: 'navbar-desktop-small-image-blocks',
        },
      },
    };
  },
  computed: {
    isHomepage() {
      return document.querySelector('body.template-index') ? true : false;
    },
    mobileNavClass() {
      return {
        'is-open': this.isMenuOpen === true,
      };
    },
    mobileNavSearchClass() {
      return { 'search-open': this.showSearch };
    },
    isMobileOrTablet() {
      return ['tablet', 'mobile'].includes(this.$mq);
    },
  },
  methods: {
    onMobileLanguageChange(ev, val) {
      const newLang = ev.target.value;

      const realLangifySelect = document.querySelector(
        '.ly-languages-switcher:not(.mobile-languages)'
      );

      if (realLangifySelect) {
        realLangifySelect.value = newLang;
        realLangifySelect.dispatchEvent(new Event('change'));
      }
    },
    openMenu() {
      this.isMenuOpen = true;
    },
    closeMenu() {
      this.isMenuOpen = false;
      this.showSearch = false;
    },
    openSearch() {
      this.showSearch = true;
      this.isMenuOpen = false;
    },
    closeSearch() {
      this.showSearch = false;
      this.$refs.hamburger.removeActiveState();
    },
    toggleSearch() {
      this.showSearch ? this.closeSearch() : this.openSearch();
    },
    isValidBlockType(blockType) {
      return Object.keys(this.blockTypes).indexOf(blockType) >= 0;
    },
  },
  watch: {
    $mq() {
      const $app = document.querySelector('#MainContentWrapper');

      this.mainFixed = false;
      $app.classList.remove('header-fixed');

      const offset = window.scrollY + this.$refs.main.getBoundingClientRect().y;

      if (this.isMobileOrTablet) {
        this.mainOffsetMobile = offset;
      } else {
        this.mainOffset = offset;
      }

      if (!this.isMobileOrTablet && this.isMenuOpen) {
        document.querySelector('body').classList.remove('overflow-hidden');
        this.closeMenu();
      }
    },
    isMenuOpen() {
      if (this.isMenuOpen) {
        document.querySelector('body').classList.add('overflow-hidden');
      } else {
        document.querySelector('body').classList.remove('overflow-hidden');
      }
    },
  },
  mounted() {
    let maxTime = 30000; // 30 seconds
    let timeTaken = 0;
    let intervalTime = 500;

    const getLangifyOptions = window.setInterval(() => {
      timeTaken += intervalTime;

      const realLangifySelect = document.querySelector(
        '.ly-languages-switcher:not(.mobile-languages)'
      );

      if (realLangifySelect) {
        this.langifySelectInnerHtml = realLangifySelect.innerHTML;
        window.clearInterval(getLangifyOptions);
        return;
      }

      if (timeTaken >= maxTime) {
        window.clearInterval(getLangifyOptions);
        return;
      }
    }, intervalTime);

    window.addEventListener('scroll', (ev) => {
      const $app = document.querySelector('#MainContentWrapper');
      const isFixed = this.mainFixed;
      const offset = this.isMobileOrTablet
        ? this.mainOffsetMobile
        : this.mainOffset;

      if (window.scrollY > offset && !isFixed) {
        this.mainFixed = true;
        $app.classList.add('header-fixed');
      } else if (window.scrollY <= offset && isFixed) {
        this.mainFixed = false;
        $app.classList.remove('header-fixed');
      } else if (window.scrollY > 0 && window.scrollY < offset) {
        this.mobileMenuOffset = 54 + (offset - window.scrollY);
      } else {
        this.mobileMenuOffset = 0;
      }
    });
  },
};
</script>

<style scoped lang="scss">
// Desktop + Mobile Styles

@mixin header-light {
  // Defaults: Background Color
  background-color: $color-white;
  transition: background-color 150ms ease-in;

  // Defaults: Logo color
  & /deep/ #main-logo-fill {
    fill: $color-black;
  }
  // Defaults: Main Header Icon Colors
  & /deep/ .icon {
    fill: $color-black;
  }

  // Defaults: Accordion Header Icon Colors (Mobile)
  & /deep/ .accordion__header .icon {
    fill: $color-white;
  }

  // Defaults: Hamburger Colors
  & /deep/ .hamburger-inner {
    background-color: $color-black;
    &:before,
    &:after {
      background-color: $color-black;
    }
  }

  // Defaults: Main Menu Links
  .header__menu-main-link-text {
    color: $color-white;
    @include desktop-up {
      color: $color-black;
    }
  }

  & /deep/ .search-form__close .icon {
    fill: $color-black !important;
  }

  & /deep/ .search-form__submit .icon {
    fill: $color-black !important;
  }
}

@mixin header-dark {
  & /deep/ #main-logo-fill {
    fill: $color-white;
  }
  & /deep/ .icon {
    fill: $color-white;
  }

  & /deep/ .hamburger-inner {
    background-color: $color-white;
    &:before,
    &:after {
      background-color: $color-white;
    }
  }
  .header__menu-main-link-text {
    color: $color-white;
    @include desktop-up {
      color: $color-white;
    }
  }
}

.navbar {
  display: flex;
  position: absolute;
  z-index: 101;

  &__search {
    display: flex;
    width: 100%;
    max-width: rem(240);
    @include desktop-up {
      max-width: unset;
    }
  }
}

.main-header-nav-container {
  width: 100%;

  @include header-light;

  // Homepage Not Fixed
  &.template-index:not(.fixed) {
    // Homepage Not Fixed: Background Color
    background-color: transparent;

    &:hover {
      @include desktop-up {
        @include header-light;
      }
    }

    &.is-open,
    &.search-open {
      background-color: $color-black;
    }
  }

  // Homepage Light Not Fixed, Or Just Opened
  &.template-index.light:not(.fixed),
  &.is-open,
  &.search-open {
    @include header-dark;
  }

  &.template-index.light:not(.fixed) {
    &:hover {
      @include desktop-up {
        @include header-light;
      }
    }
  }

  // Homepage Dark Not Fixed, Or Just Opened
  &.template-index.dark:not(.fixed) {
    @include header-light;
    background-color: transparent;
    &:hover {
      @include desktop-up {
        background-color: $color-white;
      }
    }
    &.is-open,
    &.search-open {
      @include header-dark;
      background-color: $color-black;
    }
  }

  // Mobile Open
  &.is-open,
  &.search-open {
    background-color: $color-black;
  }

  // Fixed
  &.fixed {
    position: fixed;
    top: 0;
    // Fixed Mobile Dropdown
    /deep/ .is-open .nav-links-dropdown-content-container {
      @include mobile-tablet {
        top: 54px;
      }
    }
  }
}

.main-header-nav-inner-container {
  display: flex;
  width: 100%;
  height: 54px;
  justify-content: space-between;

  @include desktop-up {
    height: 80px;
    flex-direction: row;
    justify-content: space-between;
  }
}

.nav-links-dropdown-inner-content-container {
  display: flex;

  @include mobile-tablet {
    flex-direction: column;
    position: relative;
    min-height: calc(100vh - 100px);
  }

  @include desktop-up {
    justify-content: center;
  }
}

.nav-main-links-container {
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  background-color: $color-black;

  @include desktop-up {
    flex-direction: row;
    background-color: transparent;
  }
}

.header__menu-item {
  list-style: none;

  &:hover .header__dropdown-container {
    display: block;
  }

  &:hover .header__menu-main-link {

    @include desktop-up {
      &:before {
        content: '';
        position: absolute;
        width: 0px;
        height: 0px;
        top: 74px;
        left: 50%;
        transform: translate(-50%, -50%);
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 10px solid $color-white;
      }
      &-text {
        position: relative;

        &:after {
          content: '';
          position: absolute;
          width: 100%;
          height: 2px;
          background: $color-black;
          left: 0;
          bottom: -1px;
        }
      }
    }
  }

  &:hover .header__menu-main-link--solo {
    &:before {
      content: none;
    }
  }
}

.header__dropdown-container {
  background-color: #111111;

  @include desktop-up {
    position: absolute;
    width: 100%;
    left: 0;
    top: 99%;
    background-color: $color-white;
    z-index: 33;
    padding-top: 46px;
    padding-bottom: 46px;
    display: none;
  }
}

/deep/ .header__menu-main-link {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  line-height: rem(36);
  font-size: rem(18);
  padding: 16px 52px;
  letter-spacing: normal;
  color: $color-black;
  font-family: $font-family-primary;
  font-weight: 500;
  height: 80px;
  text-decoration: none;

  @include desktop-up {
    background-color: transparent;
    padding: 0 16px;
    padding-left: 16px;
    font-size: 16px;
    letter-spacing: normal;
    line-height: 1.25;
    font-weight: 400;
  }

  .accordion__title {
    font-size: inherit;
    font-weight: inherit;
  }
}

.header__menu-main-link-text {
  font-family: $font-family-secondary;
  font-size: rem(18);
  letter-spacing: normal;
  font-weight: 500;

  @include desktop-up {
    text-transform: uppercase;
    font-size: 12px;
    letter-spacing: 1.5px;
  }
}

.is-open .nav-links-dropdown-content-container {
  @include mobile-tablet {
    display: block;
    position: fixed;
    top: 82px;
    left: 0;
    background-color: $color-black;
    width: 100%;
    height: calc(100% - 70px);
    overflow: scroll;
    transform: translateX(0);
    transition: transform 0.3s ease-in-out;
    z-index: 1;
    padding-bottom: 60px;
  }
}

.nav-links-dropdown-content-container {
  display: none;

  @include mobile-tablet {
    display: none;
    position: fixed;
    top: 82px;
    left: -100%;
    background-color: $color-white;
    width: 100%;
    height: calc(100% - 70px);
    overflow: scroll;
    transform: translateX(-100%);
    transition: transform 0.3s ease-in-out;
    z-index: 1;
  }

  @include desktop-up {
    display: block;
    flex: 1;
  }
}

.logo-nav-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-basis: 0;
  flex-grow: 4;

  @include desktop-up {
    justify-content: flex-start;
  }
}

.header-logo {
  max-width: 150px;
}

.desktop-header-search-container,
.mobile-hamburger-container,
.mobile-search-icon-form-container {
  cursor: pointer;
}

/* MOBILE */
.mobile-cart-menu-container {
  display: flex;
  align-items: center;

  @include desktop-up {
    display: none;
  }
}

.mobile-search-icon-form-container,
.mobile-cart-menu-container {
  display: flex;
  align-items: center;

  @include desktop-up {
    display: none;
  }
}

.mobile-search-icon-form-container {
  justify-content: flex-start;
  flex-grow: 3;
  flex-basis: 0;
}

.mobile-cart-menu-container {
  justify-content: flex-end;
  flex-grow: 3;
  flex-basis: 0;
}

.navbar__mobile__linklist {
  display: flex;
  flex-direction: column;
  margin-bottom: 52px;
}

.mobile-dropdown__helper-links-main-container {
  display: flex;
  flex-direction: column;
  padding: 6px 52px;
  margin: 0;
  height: 55px;
  border-top: 1px solid $color-off-black;
  justify-content: center;

  @include desktop-up {
    display: none;
  }
}

.mobile-dropdown__helper-main-link-container {
  margin-bottom: 0;
}

.mobile-dropdown__helper-links-container {
  list-style: none;
  padding-left: 0;
}

.mobile-helper-icon {
  width: 20px;
  height: 20px;
}

.mobile-dropdown__helper-main-link {
  margin-bottom: 0;
  color: $color-white;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
}

.mobile-dropdown__helper-link {
  color: $color-black;
  margin-bottom: 16px;
  display: block;
}

.mobile-helper-title {
  margin: 0;
  font-size: 16px;
}

.mobile-dropdown__helper-main-link {
  display: flex;
  align-items: center;
}

.mobile-dropdown__helper-links-container {
  margin: 0;
  padding: 0;
}

/* SEARCH */
.navbar__mobile__nav--search {
  @include mobile-tablet {
    position: absolute;
    top: 54px;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.15);
  }
}

.navbar__mobile__nav--search .button__content {
  display: flex;
}

.desktop-header-search-cart-container {
  display: none;

  @include desktop-up {
    display: flex;
    align-items: center;
    padding: 20px 0;
    position: relative;
    > div {
      margin-right: 20px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
}

.header-search-container {
  display: flex;
  align-items: center;
  position: relative;
  height: 40px;
  min-width: 32px;
}

.header-search-form-container {
  position: absolute;
  top: 0;
  width: 280px;
  display: none;
  height: 100%;
  overflow: hidden;
  z-index: 60;
  transform: translateX(100%);
  border: 1px solid $color-off-white;
  background-color: $color-white;
}

.active-accordion .icon-plus-path {
  fill: $color-brand-tertiary !important;
}
</style>
